import axios from 'axios';
import * as vars from './vars';

export function authenticateUser(credentials) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/untrusted/admin/AuthenticateLogin`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: credentials
    })
}

export function validateAuthentication(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/ValidateAuthentication`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function validateSessionToken(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/authentication/ValidateSessionToken`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
    })
}
